<template>
  <div>
    <div class="loginelse">
      <a href="javaScript:" @click="goPhone">
        <img
          v-if="this.$route.path !== '/'"
          src="~img/account/phone.png"
          alt=""
        />
        <img
          v-if="this.$route.path == '/'"
          src="~img/account/userlogin.png"
          alt=""
        />
      </a>
      <a :href="qqurl"><img src="~img/account/qq.png" alt=""/></a>
      <a :href="weixinLogin"><img src="~img/account/weixin.png" alt=""/></a>
    </div>
    <p>
      * 点击登录代表同意【源石】 <a href="javaScript:">用户协议</a> 和
      <a href="javaScript:">隐私政策</a>
    </p>
  </div>
</template>

<script>
import { BENDI } from "apiurl/index.js";
export default {
  data() {
    return {
      qqurl: "",
      weixinLogin: ""
    };
  },
  methods: {
    goPhone() {
      if (this.$route.path == "/") {
        if (this.$route.query.redirect) {
          this.$router.push(`/login?redirect=${this.$route.query.redirect}`);
        } else {
          this.$router.push(`/login`);
        }
      } else {
        if (this.$route.query.redirect) {
          this.$router.push(`/?redirect=${this.$route.query.redirect}`);
        } else {
          this.$router.push(`/`);
        }
      }
    }
  },
  mounted() {
    let backUrl = "/";
    if (this.$route.query.redirect) {
      backUrl = this.$route.query.redirect;
    }
    this.qqurl = `${BENDI}/third/auth/login?thirdType=2&backUrl=${backUrl}`;
    this.weixinLogin = `${BENDI}/third/auth/login?thirdType=3&backUrl=${backUrl}`;
  }
};
</script>

<style lang="stylus" scoped>
.loginelse
    margin-top 25px
    margin-bottom 30px
    padding 0 40px
    a
        width 42px
        height 42px
        margin-right 47px
        &:last-child
            margin-right 0
p
    font-size: 12px
    color #C3C3C3
    text-align center
    a
        color #3066AF
        text-decoration underline
</style>
